import { MutationTree } from "vuex";

import { State } from "./state";
import { AlertMutationTypes as MutationTypes } from "./mutation-types";

export type Mutations<S = State> = {
  [MutationTypes.SET_ALERTCONDITION_CATS](state: S, payload: Array<any>): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_ALERTCONDITION_CATS](state, payload: any) {
    state.alertConditionCats = payload;
  },
};false
